export default "__VITE_ASSET__CLCJvRH9__"